import React from 'react';
import { Col, Row } from 'react-bootstrap';
import * as Formatting from 'fw/misc/Formatting';
import { Link } from 'fw/components/formatter/Formatter';
import { SetupTab } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';
import * as App from 'modules/app/App';
import * as Modals from 'fw/globals/Modals';
import * as Notifications from 'fw/globals/Notifications';
import SponsorSelectionPopUp from './SponsorSelectionPopUp';
import { ActionButton } from 'fw/components';

class PaypalInvoiceInfoTab extends SetupTab {
    initialForm() {
        return {
            retrievingDetail: false,
            showImportSponsorSelectPopUp: false,
        }
    }

    urls() {
        return {
            get: API.Admin.url('/paypalInvoice/GetPaypalInvoiceInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            paypalInvoiceId: this.props.selectedId
        }
    }

    privileges() {
        return {
        }
    }

    ready = () => {
        this.getUpdateInvoiceFromPaypal();
    }

    getUpdateInvoiceFromPaypal() {
        const me = this;
        if (this.state.form.imported)
            return;
        
        this.setState({
            form: {
                ...this.state.form,
                retrievingDetail: true
            }
        });
        
        var rq = {
			paypalInvoiceId: this.props.selectedId
		};

        API.Admin.get('/paypalInvoice/getUpdateInvoiceFromPaypal',
			rq,
			{
				success: (r) => {
					me.setState({
						form: {
							...r.data,
                            retrievingDetail: false,
							original: JSON.parse(JSON.stringify(r.data)),
						},
					});
                    me.props.onSuccess(r.message);
				},
				error: (r) => {
					me.props.onError(r.error);
					me.setState({
						form: {
                            ...me.state.form,
							retrievingDetail: false
						},
					});
				},
			},
			{ block: false }
		);
	}

    renderField = (fieldData) => {
        if (fieldData !== null && fieldData !== "")
        {
            return(
                <React.Fragment>
                    {fieldData}
                    <br />
                </React.Fragment>
            );
        }
        else 
            return null
    }

    renderEmailField = (fieldData) => {
        if (fieldData !== null && fieldData !== "")
        {
            return(
                <React.Fragment>
                    <a href={`mailto:${fieldData}`}>{fieldData}</a>
                    <br />
                </React.Fragment>
            );
        }
        else 
            return null
    }

    renderPhoneField = (fieldData) => {
        if (fieldData !== null && fieldData !== "")
        {
            return(
                <React.Fragment>
                    <a href={`tel:${fieldData}`}>{fieldData}</a>
                    <br />
                </React.Fragment>
            );
        }
        else 
            return null
    }

    renderFullName = (firstName, lastName) => {
        if (!firstName && !lastName)
            return null
        else if (!firstName)
            return this.renderField(lastName);
        else if (!lastName)
            return this.renderField(firstName);
        else
            return this.renderField(firstName + " " + lastName);
            
    }

    renderCountry = (countryCode) => {
        if (countryCode === 'US' )
            return this.renderField('United States');
        else
            return this.renderField(countryCode);
    }

    renderCity = (city, state, postalCode ) => {
        if (!city && !state && !postalCode)
            return null;
        else
        {
            let rightText = "";
            if (state !== null && state !== "")
                rightText = state;
            if (postalCode !== null && postalCode !== ""){
                if (rightText !== "")
                    rightText = rightText + " ";
                rightText = rightText + postalCode;
            }
            
            if (rightText === "")
                return this.renderField(city);
            else{
                if (city !== null && city !== "")
                    return this.renderField(city + ", " + rightText);
                else
                    return this.renderField(rightText);
            }
        }
        
    }

    renderInvoiceDetailRow = (item, i) => {
        const row = (
            <tr key={i}>
                <td className="react-grid-Cell">
                    <h4><b>{item.name}</b></h4>
                    <p>
                        {Formatting.nl2br(item.description)}
                    </p>
                </td>
                <td className="col-md-1 react-grid-Cell" style={{ textAlign: "right" }}>
                    {item.quantity}
                </td>
                <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                    {Formatting.formatSignedCurrency(item.unitAmount)}
                    <br />
                    { item.discountPercent 
                        ? "(" + item.discountPercent + "% Discount)"
                        : (item.discountAmount 
                            ? "(" + Formatting.formatSignedCurrency(item.discountAmount) + " Discount)"
                            : null)
                    }
                </td>
                <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                    {Formatting.formatSignedCurrency(item.subTotalAmount)}
                    { item.taxable ? "*" : null}
                    <br />
                    { item.discountAmount 
                        ? Formatting.formatSignedCurrency(item.discountAmount)
                        : null
                    }
                </td>
            </tr>
        );

        return [row]
    }

    renderInvoiceTotals = () => {
        const form = this.state.form;
        const rows = (
            <React.Fragment>
                <tr>
                    <td colSpan={3} className="react-grid-Cell" style={{ textAlign: "right" }}>
                        <h4>Subtotal</h4>
                    </td>
                    <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                        <h4>{Formatting.formatSignedCurrency(form.totalItemAmount)}</h4>
                    </td>
                </tr>
                { form.ItemDiscounts ? 
                    <tr>
                        <td colSpan={3} className="react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>Item Discounts</h4>
                        </td>
                        <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>{Formatting.formatSignedCurrency(form.ItemDiscounts)}</h4>
                        </td>
                    </tr>
                : null }
                { form.otherDiscountAmount ? 
                    <tr>
                        <td colSpan={3} className="react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>
                                Other Discount
                                <br />
                                { form.otherDiscountPercent
                                    ? "(" + form.otherDiscountPercent + "%)"
                                    : (form.otherDiscountAmount 
                                        ? "(" + Formatting.formatSignedCurrency(form.otherDiscountAmount) + " Discount)"
                                        : null)
                                }
                            </h4>
                        </td>
                        <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>{Formatting.formatSignedCurrency(form.otherDiscountAmount)}</h4>
                        </td>
                    </tr>
                : null }
                { form.shippingAmount ? 
                    <tr>
                        <td colSpan={3} className="react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>Shipping</h4>
                        </td>
                        <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>
                                {Formatting.formatSignedCurrency(form.shippingAmount)}
                                { form.shippingTaxable ? "*" : null}
                            </h4>
                        </td>
                    </tr>
                : null }
                { form.taxesAmount ?
                    <tr>
                        <td colSpan={3} className="react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>Taxes</h4>
                        </td>
                        <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>{Formatting.formatSignedCurrency(form.taxesAmount)}</h4>
                        </td>
                    </tr>
                : null }
                { form.customAmount ? 
                    <tr>
                        <td colSpan={3} className="react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>{form.customLabel}</h4>
                        </td>
                        <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                            <h4>{Formatting.formatSignedCurrency(form.customAmount)}</h4>
                        </td>
                    </tr>
                : null }
                <tr>
                    <td className="react-grid-Cell">
                    </td>
                    <td colSpan={2} className="col-md-3 react-grid-Cell" style={{ textAlign: "right" }}>
                        <h4><b>Total</b></h4>
                    </td>
                    <td className="col-md-2 react-grid-Cell" style={{ textAlign: "right" }}>
                        <h4>{Formatting.formatSignedCurrency(form.invoiceTotalAmount)}</h4>
                    </td>
                </tr>
            </React.Fragment>
        );

        return [rows]
    }

    renderBusinessName = () => {
        const billingBusinessName = this.state.form.billingBusinessName;
        const sponsorId = this.state.form.sponsorId;

        if (!billingBusinessName)
            return null;
            
        if (!sponsorId)
            return this.renderField(billingBusinessName);

        var url = `/admin/sponsorSetup/${sponsorId}/sponsorHistory`;
        var linkValue = {
            url: url,
            title: billingBusinessName
        };

        return(
            <React.Fragment>
                <Link targetBlank={true} value={linkValue}></Link>
                <br />
            </React.Fragment>
        );
    }

    renderInvoiceDetailTable = () => {
        return (
            <React.Fragment>
                <table className="table table-striped table-bordered table-condensed">
                    <thead>
                        <tr>
                            <th className="react-grid-HeaderCell"><h4>Description</h4></th>
                            <th className="react-grid-HeaderCell" style={{ width: "180px", textAlign: "right" }}><h4>{Formatting.capitalize(this.state.form.unitOfMeasure)}</h4></th>
                            <th className="react-grid-HeaderCell" style={{ width: "170px", textAlign: "right" }}><h4>Price</h4></th>
                            <th className="react-grid-HeaderCell" style={{ width: "170px", textAlign: "right" }}><h4>Amount</h4></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.form.paypalInvoiceItems && this.state.form.paypalInvoiceItems.map((item, i) => {
                            return this.renderInvoiceDetailRow(item, i);
                        })}
                        {this.renderInvoiceTotals()}
                    </tbody>
                </table>
            </React.Fragment>
        )
    }

    getBusy = () => {
        this.setState({
            busy: true
        });
    }

    onImportInvoicePopUpClose = () => {
        this.setState({
            showImportSponsorSelectPopUp: false
        });
    }

    onImportInvoicePopUpOpen = () => {
        this.setState({
            showImportSponsorSelectPopUp: true
        });
    }

    onImportNewCM = () => {
        if (this.state.form.matchedSponsorId)
        {
            Notifications.error("Corporate Member '" + this.state.form.billingBusinessName + "' already exists.");
            return;
        }

        var me = this;
        var url = `/admin/sponsorSetup/new?paypalInvoiceId=${this.state.form.paypalInvoiceId}`;
        Modals.confirm(
            "Import Invoice will import the selected PayPal Invoice and will populate a new Corporate Member profile based on its data. <br /><br />" +
            "If you wish to proceed, please select 'Yes'. <br /><br />" +
            "If you wish to Discard this change, please select 'No' and you will be returned to the previous screen.",
            function () {
                me.getBusy();
                window.location.href = url;
            }
        );
    }

    renderLoading = () => {
        return (
            <React.Fragment>
                <br />
                <p className="login-box-heading">We are retrieving and updating invoice information from PayPal ...</p>
                <br />
                <div className="text-center">
                    <img src="/images/spinner.gif" alt="..." />
                </div>
                <br />
                <br />
                <p className="login-box-heading">... just a moment!</p>
                <br />
                <br />
            </React.Fragment>
        );
    }

    renderInvoice = () => {
        let labelClass = "label label-default";
        if (this.state.form.isPaid)
            labelClass = "label label-success";

        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 className="inline">
                            Invoice # {this.state.form.invoiceNumber} &nbsp;
                            <small>
                                &nbsp;&nbsp;<span className={labelClass}>{this.state.form.invoiceStatus}</span>
                            </small>
                        </h3>
                    </Col>
                </Row>
                <br />
                <hr />
                <Row>
                    <Col md={4}>
                        <h4><b>Bill To</b></h4>
                        {this.renderBusinessName()}
                        {this.renderFullName(this.state.form.billingFirstName, this.state.form.billingLastName)}
                        {this.renderField(this.state.form.billingAddressLine1)}
                        {this.renderCity(this.state.form.billingAdminArea2, this.state.form.billingAdminArea1, this.state.form.billingPostalCode)}
                        {this.renderCountry(this.state.form.billingCountryCode)}
                        
                        <br/>
                        {this.renderEmailField(this.state.form.billingEmail)}
                        {this.renderPhoneField(this.state.form.billingPhone)}
                    </Col>
                    <Col md={4}>
                        <h4><b>Ship To</b></h4>
                        {this.renderField(this.state.form.shippingAddressLine1)}
                        {this.renderCity(this.state.form.shippingAdminArea2, this.state.form.shippingAdminArea1, this.state.form.shippingPostalCode)}
                        {this.renderCountry(this.state.form.shippingCountryCode)}
                        
                        <br />
                        {this.renderField(this.state.form.shippingEmail)}
                    </Col>
                    {App.hasPrivilege("AdminSponsorSetupAdd") ?
                        <Col md={4} style={{ textAlign:'right' }}>
                            <p>
                                <b>Invoice Date:</b>
                                &nbsp;{Formatting.formatDate(this.state.form.invoiceDate)}
                            </p>
                            <p>
                            <b>Due Date:</b>
                            &nbsp;{Formatting.formatDate(this.state.form.invoiceDueDate)}
                            </p>
                            {this.state.form.detailRetrievedDate ?
                                <p>
                                    <b>Detail retrieved from PayPal:</b>
                                    &nbsp;{Formatting.formatClientDateTime(this.state.form.detailRetrievedDate)}
                                </p>
                            : 
                                <p>
                                    <em>Pending detail retrieve from PayPal.</em>
                                </p>
                            }
                            {!this.state.form.imported ?
                                <span className="pull-right" style={{textAlign:"right"}}>
                                    <SponsorSelectionPopUp
                                        visible={this.state.showImportSponsorSelectPopUp}
                                        onClose={this.onImportInvoicePopUpClose}
                                        searchText={this.state.form.billingBusinessName}
                                        paypalInvoiceId={this.props.selectedId} />
                                    <ActionButton 
                                        id='btnCreateSponsor' 
                                        onClick={this.onImportInvoicePopUpOpen}
                                        icon='import'>
                                        &nbsp;Import Invoice
                                    </ActionButton>
                                    
                                    <ActionButton 
                                        id='btnCreateSponsor' 
                                        onClick={this.onImportNewCM}
                                        icon='plus'>
                                        &nbsp;Import New CM
                                    </ActionButton>
                                </span>
                            :
                                <h4>
                                    <span className="pull-right label label-success">
                                        Invoice Imported
                                    </span>
                                </h4>
                            }
                        </Col>
                    : null}
                </Row>
                <hr />
                <Row>
                    <Col md={12}>
                        {this.renderInvoiceDetailTable()}
                        <em style={{ textAlign:'right', color:'#bfb1b0' }}><h4>*Taxable Item</h4></em>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    renderForm() {
        if (this.state.form.retrievingDetail)
            return this.renderLoading();
        else
            return this.renderInvoice();
    }
}

export default PaypalInvoiceInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/paypalInvoiceSetup/paypalInvoiceInfo/PaypalInvoiceInfoTab.js